<template>
    <div class="container">
        <header class="header">
            <!--            <h2 class="studentName">{{ getStudentInfo.studentName }}</h2>-->
            <!--            <p>专业：{{ getStudentInfo.professionalName }}</p>-->
            <!--            <p>班级：{{ getStudentInfo.schoolClassName }}</p>-->
            <!--            <p>待缴费：<span style="color:red">￥ {{ getPayStatus ? '&#45;&#45;' : toBePaid }}</span></p>-->
            <p>姓名：<span>{{ studentInfo.studentName }}</span></p>
            <p>身份证：<span>{{ studentInfo.studentIdCard }}</span></p>
            <p>专业：<span>{{ studentInfo.professionalName}}</span></p>
            <template v-if="studentInfo.payStatus===1">
                <p class="payMsg">{{studentInfo.payMsg}}</p>
            </template>
            <template v-else>
                <template v-if="studentInfo.payType === 1">
                    <el-button type="primary"  @click="pay_dialog.visible=true">去支付</el-button>
                </template>
                <template v-else>
                    <p class="payMsg">{{studentInfo.payMsg}}</p>
                </template>
            </template>
            <!--            <el-button type="info" @click="download">导出缴费信息</el-button>-->
        </header>
        <main>
            <p class="blStyle">缴费信息</p>
            <el-table
                :data="tableData"
                style="width: 100%"
                empty-text="没有找到匹配的记录"
            >
                <el-table-column
                    v-for="col in tableColumn"
                    :key="col.prop"
                    :prop="col.prop"
                    :label="col.label"
                    align="center"
                    :width="col.width||'auto'"/>
                <el-table-column key="payType" prop="payType" align="center" label="支付方式">
                    <template slot-scope="scope">
                        <template v-if="scope.row.payType==='local'">
                            <span class="localPay">线下支付</span>
                        </template>
                        <template v-else>
                            <img
                                :src="scope.row.payType==='微信支付'?require('../assets/wechat.png'):require('../assets/alipay.png')"
                                alt="">
                        </template>

                    </template>
                </el-table-column>
                <el-table-column key="payStatusText" prop="payStatusText" align="center" label="缴费状态">
                    <template slot-scope="scope">
                        <span
                            :style="{color:scope.row.payStatus=='1'?'green':'red'}">{{ scope.row.payStatusText }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </main>
        <el-dialog :title="pay_dialog.title" :visible.sync="pay_dialog.visible" append-to-body class="payDialog"
                   width="600px">
            <el-row>
                <el-col :offset="2">
                    <span>支付金额</span>
                    <span class="money">￥{{ toBePaid }}</span>
                </el-col>
            </el-row>
            <el-row>
                <el-col :offset="2">
                    <span>支付订单号</span>
                    <span>{{ payId }}</span>
                </el-col>
            </el-row>
            <el-row>
                <el-col :offset="2">
                    <div class="typeBox">
                        <span>支付方式</span>
                        <img src="../assets/wechat.png" alt="" :class="pay_dialog.payType=='wechat'?'selected':''"
                             @click="changePayType('wechat')">
                        <img src="../assets/alipay.png" alt="" :class="pay_dialog.payType=='alipay'?'selected':''"
                             @click="changePayType('alipay')">
                    </div>
                </el-col>
            </el-row>
            <el-dialog
                width="500px"
                :visible.sync="pay_dialog.inner_dialog.visible"
                append-to-body
                class="payInnerDialog"
            >
                <div slot="title" class="dialog-title" style="display: flex;align-items: center">
                    <img
                        :src="pay_dialog.payType==='wechat'?require('../assets/wechat.png'):require('../assets/alipay.png')"
                        alt="">
                    <span style="margin-left: 1em">{{ pay_dialog.inner_dialog.title }}</span>
                </div>
                <div v-if="pay_dialog.payType==='wechat'" id="qrcode" ref="qrcode"
                     style="border: none;margin-left: 50%;transform: translateX(-50%)"></div>
                <iframe v-else :src="pay_dialog.inner_dialog.imgSrc" width="200px" height="210px"
                        style="border: none;margin-left: 50%;transform: translateX(-50%)"></iframe>
                <p class="tip" style="color:red;text-align: center;padding-bottom: 20px;">请扫码支付 ￥{{ toBePaid }}</p>
            </el-dialog>
            <div slot="footer" class="dialog-footer" align="center">
                <el-button @click="pay_dialog.visible = false">关 闭</el-button>
                <el-button type="primary" @click="goPay">立即支付</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {
    getOnlinePrice,
    downloadPayList,
    getWeChatPayQRCode,
    getAliPayQRCode,
    createPayId,
    getStudentPayInfo,
    getPayList
} from "../common/services";
import QRCode from 'qrcodejs2'
import {downloadFile, transferParams2Str} from "../utils";
import APIDOC from "../common/serverApi";

const PAYMENT = APIDOC.PAYMENT;


export default {
    components: {},
    data() {
        return {
            tableColumn: [
                {prop: "studentNo", label: "学号"},
                {prop: "studentName", label: "姓名"},
                {prop: "grade", label: "年级"},
                {prop: "professionalName", label: "专业"},
                // {prop: "payType", label: "支付方式"},
                // {prop: "payStatusText", label: "缴费状态"},
            ],
            tableData: [],
            toBePaid: 0,//待支付金额
            payId: undefined,//支付订单号
            pay_dialog: {
                visible: false,
                title: "选择支付方式",
                payType: "wechat",
                inner_dialog: {
                    imgSrc: "",
                    visible: false,
                    title: "微信支付",
                }
            },
            studentInfo:{
                studentName:"",
                studentIdCard:"",
                professionalName:"",
                payMsg:"",      //缴费信息
                payStatus:1   //1已缴费 0未缴费
            },
            payStatusTimeout:null,
        }
    },

    created() {
        this.initData();
    },
    methods: {
        changePayType(type = 'wechat') {
            this.pay_dialog.payType = type;
            this.pay_dialog.inner_dialog.imgSrc = "";
        },
        getWeChatQrcode(text) {
            this.$refs.qrcode.innerHTML = "";
            return new QRCode('qrcode', {
                width: 200, // 设置宽度，单位像素
                height: 200, // 设置高度，单位像素
                text,   // 设置二维码内容或跳转地址
            })

        },
        initData() {
            getStudentPayInfo().then(res => {
                this.studentInfo = res.data?res.data:{};
                if(this.studentInfo.payType == 1 && this.studentInfo.payStatus == 2){
                    this.payStatusTimeout = setInterval(()=>{ //轮训获取支付状态。
                        this.getPayStatusTimeout();
                    },3500);
                }
            })
            getPayList({}).then(res => {
                this.tableData = res.data;
            });
            getOnlinePrice().then(res => {
                this.toBePaid = res.data;
            });
            createPayId().then(res => {
                this.payId = res.data;
            });
        },
        getPayStatusTimeout(){ //用于轮训查询缴费状态
            this.$store.dispatch("user/getStudentPayStatus").then((ret) => {
                if(ret.code == 0){
                    if(ret.data.payStatus == 1 && this.payStatusTimeout != null){ //1已缴费  2未交费
                        this.pay_dialog.visible = false;
                        this.pay_dialog.inner_dialog.visible = false;
                        this.initData();
                        clearInterval(this.payStatusTimeout);
                    }
                }
            }).catch(() => {

            });
        },
        async getPayQRCode(type = 'wechat') {
            //支付宝直接获取地址展示，微信获取到之后要将文本转成二维码
            const fn = type === 'wechat' ? getWeChatPayQRCode : getAliPayQRCode;
            const res = await fn(this.payId);
            //区分微信、支付宝
            if (type == 'wechat') {
                const imgPath = this.getWeChatQrcode(res.data);
                console.log(imgPath)
                return "";
            } else {
                return res.data;
            }
        },
        async goPay() {
            const originDialog = this.pay_dialog;
            const originInnerDialog = originDialog.inner_dialog;
            const payType = originDialog.payType;
            this.pay_dialog.inner_dialog = {
                ...originInnerDialog,
                visible: true,
                title: payType === 'wechat' ? '微信支付' : '支付宝支付'
            }
            const imgPath = await this.getPayQRCode(payType);
            console.log('获取到的图片地址', imgPath);
            this.pay_dialog.inner_dialog.imgSrc = imgPath;
        },
        async download() {
            const studentInfo = this.getStudentInfo;
            const params = {
                page: 1,
                limit: 20,
                studentName: studentInfo.studentName,
                studentNo: studentInfo.studentNo,
                studentIdCard: studentInfo.studentIdCard,
            }
            const paramStr = transferParams2Str(params);
            const url = PAYMENT.payStatus + paramStr;
            console.log("请求地址", url)
            downloadFile(url, "导出文件", {type: "GET"})
            // const res = await downloadPayList(params, {
            //     headers: {
            //         'JT_S_01_2_token':this.getToken
            //     }
            // });
            // console.log('拿到的文件流', )

        }
    },
    beforeDestroy() { //销毁前执行
        if(this.payStatusTimeout != null){ //停止支付状态轮训
            clearInterval(this.payStatusTimeout);
        }
    }
}
</script>

<style lang="less" scoped>
.container {
    > header {

        background-color: #FFF;
        padding: 2em 6em 2em 6em;

        > p {
            font-weight: 700;
        }

        > p > span {
            margin-left: 5px;
        }

        .payMsg{
            color: red;
        }
        //*:not(h2) {
        //    padding-left: 1em;
        //}
    }

    > main {
        > p.blStyle {
            border-left: 4px solid #00ffff;
            padding-left: 1em;
        }

        .localPay {
            color: red;
        }
    }


}

</style>
<style lang="less">
.payDialog {
    .el-col {
        line-height: 3em;

        span {
            &.money {
                color: red;
            }

            &:nth-child(2) {
                margin-left: 1em;
            }
        }

        .typeBox {
            span {
                line-height: 50px;
                vertical-align: top;
                display: inline-block;
            }

            img {
                margin-left: 2em;
                padding: 10px;
                border: 1px solid transparent;

                &.selected {
                    border-color: lightgrey;
                    box-shadow: 0 0 1px grey inset;
                    border-radius: 10px;
                }

            }
        }

    }

    p.tip {
        margin-bottom: 3em;
    }

    .payInnerDialog {

    }
}
</style>



// WEBPACK FOOTER //
// src/pages/myFinances.vue